module.exports = __webpack_public_path__ + "img/logo.ef67e0ee.png";